import clsx from 'clsx';
import { FC, PropsWithChildren } from 'react';
import { LandingImageTextTileItemStoryblok } from 'storyblok-types';
import { Image } from 'atoms/Image/Image';
import { StoryBlokLink } from 'atoms/StoryBlokLink';
import { Title } from 'atoms/Typography/Typography';
import { RichTextMarkdown } from '../RichText';
import styles from './styles.module.css';

const Tag: FC<
  PropsWithChildren<Pick<LandingImageTextTileItemStoryblok, 'link'>>
> = ({ link, children }) => {
  return link?.url ? (
    <StoryBlokLink link={link} className={clsx(styles.item, styles.link)}>
      {children}
    </StoryBlokLink>
  ) : (
    <div className={styles.item}>{children}</div>
  );
};

export const LandingImageTextTileItem: FC<{
  blok: LandingImageTextTileItemStoryblok;
}> = ({ blok }) => {
  const { image, title, link, richText } = blok;
  return (
    <Tag link={link}>
      <Image src={image.filename} alt={image?.alt} className={styles.img} />
      {(richText || title) && (
        <div className={styles.textBlock}>
          <Title tag="h3" type="lg" color="purple" className={styles.title}>
            {title}
          </Title>
          <RichTextMarkdown
            text={richText}
            components={{
              p: ({ children }) => (
                <Title tag="p" type="md" className={styles.p}>
                  {children}
                </Title>
              ),
            }}
          />
        </div>
      )}
    </Tag>
  );
};
